import { create } from 'zustand';

type Theme = 'light' | 'dark';

function getInitialTheme(): Theme {
  return 'light';
}

function applyTheme(_theme: Theme) {
  const root = document.documentElement;
  root.classList.remove('dark');
  localStorage.setItem('waypoint-theme', 'light');
}

interface UIStore {
  mobileNavOpen: boolean;
  toggleMobileNav: () => void;
  setMobileNavOpen: (open: boolean) => void;
  // Theme
  theme: Theme;
  toggleTheme: () => void;
  // Keep legacy aliases so nothing breaks if referenced elsewhere
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => {
  // Apply saved theme on store creation
  const initialTheme = getInitialTheme();
  applyTheme(initialTheme);

  return {
    mobileNavOpen: false,

    toggleMobileNav: () =>
      set((state) => ({
        mobileNavOpen: !state.mobileNavOpen,
      })),

    setMobileNavOpen: (open) =>
      set({
        mobileNavOpen: open,
      }),

    // Theme
    theme: initialTheme,
    toggleTheme: () => {
      applyTheme('light');
      set({ theme: 'light' });
    },

    // Legacy — no longer drives layout but kept for compatibility
    sidebarCollapsed: false,
    toggleSidebar: () =>
      set((state) => ({
        sidebarCollapsed: !state.sidebarCollapsed,
      })),
    setSidebarCollapsed: (collapsed) =>
      set({
        sidebarCollapsed: collapsed,
      }),
  };
});
